// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__3hMWv","message":"CookieConsent_message__DK9ON","cookieLink":"CookieConsent_cookieLink__hy1iT","continueBtn":"CookieConsent_continueBtn__2obwa"};